module.exports = __webpack_public_path__ + "static/media/chart.6124f1d5.png";